import styled from 'styled-components';

const TermsPage = () => {
    return (
        <Container>
            <Heading>Terms of Use (We believe its Trust)</Heading>

            <SectionTitle>1. Our Intention</SectionTitle>
            <Paragraph>
                Anahex exists to support sincere individuals on a daily journey of growth and self-improvement. We have built this platform with care, simplicity, and trust at its core. Our purpose is to serve those who genuinely seek knowledge, consistency, and personal upskilling. If your intent is not aligned with learning, honesty, and respectful participation, we kindly ask that you refrain from using Anahex.
            </Paragraph>
            <SectionTitle>2. Age & Eligibility</SectionTitle>
            <Paragraph>
                To use Anahex, you must be at least 18 years old. If we discover accounts of individuals underage, they will be promptly removed and data deleted.
                We will periodically review this age criterion, as the pursuit of learning has no boundaries — while always remaining compliant with applicable laws.
            </Paragraph>

            <SectionTitle>3. User Conduct & Responsibilities</SectionTitle>
            <Paragraph>
                <strong>Non-Negotiable Do's:</strong>
                <ul>
                    <li>Always treat others with respect, empathy, and kindness</li>
                    <li>Respect every user's privacy and personal boundaries</li>
                    <li>Respect individuals with disabilities or special needs without bias or judgment</li>
                    <li>Uphold the spirit of learning and integrity</li>
                </ul>
            </Paragraph>

            <Paragraph>
                You are expected to:
                <ul>
                    <li>Provide truthful information about yourself</li>
                    <li>Respect others' boundaries, choices, and dignity</li>
                    <li>Not engage in any of the following activities, which are strictly prohibited:
                        <ul>
                            <li>Nudity or sexually explicit content, including the promotion, sharing, or solicitation of nudity, or involvement in such activities through other means</li>
                            <li>Any content or behavior involving pornography, child abuse, or depictions of rape</li>
                            <li>Sexual solicitation, prostitution, or any form of sexual exploitation</li>
                            <li>Harassment, bullying, threats, or intimidation—including threatening language or behavior meant to cause fear or pressure others</li>
                            <li>Hate speech, caste-based or religious abuse, including disrespectful remarks against any language, culture, community, heritage, or fundamental rights protected under Indian law</li>
                            <li>Disrespect, ill-treatment, ridicule, targeting, or exclusion of individuals with disabilities or special needs</li>
                            <li>Promotion or encouragement of violence or unlawful behavior</li>
                            <li>Spreading misinformation, political propaganda, or unverified rumors</li>
                            <li>Promotion or glorification of drugs, addiction, or substance abuse</li>
                            <li>Disruptive negativity or incitement of communal disharmony</li>
                            <li>Any act or communication that violates Indian law or regulations</li>
                            <li>Physical or digital crimes, including cybercrime and attempts to harm, deceive, or defraud others</li>
                            <li>Actions that question the integrity of lawful authorities or undermine legal processes of the Indian state</li>
                            <li>Involvement in or promotion of terrorism, radicalization, or activities that threaten national security</li>
                            <li>Disrespect or harassment toward the LGBTQ+ community in any form</li>
                            <li>Impersonation or identity misrepresentation</li>
                            <li>Sharing your bank account, card information, UPI credentials, or make financial transactions with any other user. Please donot share these details. Anahex representatives will never ask for such information.</li>
                            <li>Tracking or attempting to find a user using social media, search engines, or other means without their explicit consent</li>
                            <li>Using Anahex with harmful intent or attempt to damage, disrupt, or misuse the platform — including but not limited to DDoS attacks, automated spam requests, system interference, or any activity that degrades platform performance or security.</li>
                            <li>Reaching out to a other user’s known circle—such as colleagues, coworkers, friends, family members, mutual connections, or community/organization groups—without consent</li>
                        </ul>
                    </li>
                    <li>Report misconduct, suspicious behavior, or abusive actions</li>
                    <li>Do not engage in arguments, confrontations, or scolding other users. If you feel unsafe or notice a violation, silently report the incident. Our team will review and take appropriate action based on platform policies and Indian law.</li>
                    <li>Do not attempt to track, follow, or find any user outside the platform—whether through social media, mutual contacts, or other digital means. Respect every individual’s choice, space, and boundaries.</li>
                </ul>
                We reserve the right to suspend or remove any account that violates these values, with or without prior notice. By using Anahex, you also grant us the legal right to pursue action—including legal prosecution—against users who knowingly or unknowingly engage in any of the above prohibited behaviors or attempt to misuse the platform in violation of Indian law.
            </Paragraph>


            <SectionTitle>4. No Dark Practices</SectionTitle>
            <Paragraph>
                At Anahex, we strongly oppose the use of any <em>dark practices</em> — design patterns that may be legally permissible but are ethically misleading. These are tactics that pressure, manipulate, or trick users into taking actions they didn’t fully intend or understand.
            </Paragraph>
            <Paragraph>
                We believe such patterns — even when subtle — erode trust. Examples of dark practices include:
                <ul>
                    <li>Hiding or delaying important information</li>
                    <li>Tricking or Forcing users into purchases, upgrades, or subscriptions</li>
                    <li>Making it intentionally hard to cancel or opt out</li>
                    <li>Using fear, guilt, or urgency to influence decisions — something we consciously avoid in all normal circumstances</li>
                    <li>Designs that mislead or confuse user choice</li>
                </ul>
                Our platform is built on clarity, mutual respect, and consent — not control. We exist as an ecosystem for safe, meaningful growth — not as an exploiter. If anything on our platform ever feels otherwise, it means we’ve gone off course. Help us stay aligned.
            </Paragraph>
            <Paragraph>
                If you ever come across anything on Anahex that feels like a dark pattern — something that nudges or traps you — please remind us of our responsibility and accountability. Your trust is sacred, and we are here to earn it every day. Let us know at <a href="mailto:support@anahex.com">support@anahex.com</a>.
            </Paragraph>

            <SectionTitle>5. Data & Privacy</SectionTitle>
            <Paragraph>
                Your data is handled as per our <a href="/privacy">Privacy Policy</a>. We do not sell or misuse your personal information.
            </Paragraph>

            <SectionTitle>6. Respect for Competition</SectionTitle>
            <Paragraph>
                We believe in ecosystem contribution and fostering a supportive, ethical space:
                <ul>
                    <li>If you are currently employed by, associated with, or legally engaged in a product or organization that operates in the learning, daily learning, Question and Answer based learning (whether directly or indirectly competing with Anahex), we kindly request that you refrain from using the platform. Your organization or its policies may include conflict-of-interest clauses, and we aim to avoid unintended ethical or legal concerns.</li>
                    <li>If you're from a competing organization and wish to explore our offerings, you're welcome — but please obtain written permission from us before using or referencing any of our platform’s features or intellectual assets. Many of our implementations result from deep thought, user engagement, and long-term effort. We hope the builder and creator in you understands this spirit. We’d love to collaborate and grow this space together — competition is not our lens, contribution is.</li>
                </ul>
            </Paragraph>

            <SectionTitle>6. Intellectual Property & Copyright</SectionTitle>
            <Paragraph>
                All content, design, logic, and visual assets on Anahex are either owned by us or appropriately licensed. If you believe your intellectual property has been used unknowingly, we sincerely apologize. Please notify us at <a href="mailto:policy@anahex.com">policy@anahex.com</a> — we are committed to reviewing such matters promptly and resolving them with care.
                Use of any of our assets requires explicit written permission. Kindly do not proceed without formal confirmation from us. For all such requests, please contact <a href="mailto:policy@anahex.com">policy@anahex.com</a>.
            </Paragraph>

            <SectionTitle>7. Limitation of Liability</SectionTitle>
            <Paragraph>
                Anahex is not liable for the actions, words, or behavior of users on this platform. While we take every measure to safeguard users, we are not accountable for any emotional, personal, or financial consequences arising from the use of anahex platform. All interactions on Anahex are at the user’s sole discretion.
            </Paragraph>
            <Paragraph>
                However, on moral and ethical grounds, if you face any challenges, we are with you. We stand firmly against any abuse of human dignity and integrity. Within our capacity, we will always strive to maintain a safe and meaningful space for humble, kind, and genuine individuals.
            </Paragraph>
            <Paragraph>
                <strong>For law enforcement:</strong> We will extend full cooperation as required under the laws of India.
            </Paragraph>
            <Paragraph>
                For any violations, concerns, or reports, please contact us at <a href="mailto:support@anahex.com">support@anahex.com</a>.
            </Paragraph>

            <SectionTitle>8. Termination</SectionTitle>
            <Paragraph>
                You may stop using the platform at any time. However, we reserve the right to terminate or suspend your account if:
            </Paragraph>
            <Paragraph>
                1. You fail to follow the platform's Do's.<br />
                2. You engage in any of the listed Don'ts.<br />
                3. You participate in any activity that violates Indian law.<br />
                4. You harm, abuse, harass, or endanger another individual on the platform.<br />
                5. You intentionally run negative campaigns aimed at damaging our brand, community, or presence.
            </Paragraph>
            <br />
            <Paragraph>
                We are committed to protecting our community. If anyone deliberately attempts to harm us or our users, we will not remain silent. We stand firmly by our values, the law of the land, and the dignity of every individual.
            </Paragraph>
            <br />

            <SectionTitle>9. Platform Access</SectionTitle>
            <Paragraph>
                Anahex may be updated and maintained from time to time. Access to the platform is not guaranteed for all individuals by default. This policy exists to protect both our platform and our users from potential abuse.
            </Paragraph>

            <SectionTitle>10. Jurisdiction</SectionTitle>
            <Paragraph>
                This agreement is governed by Indian law. Any legal claims, proceedings, or disputes must be filed only in the courts of Bengaluru, Karnataka. By using Anahex, you explicitly agree to this jurisdiction.
            </Paragraph>

            <SectionTitle>11. Platform Policies (Meta, Whatsapp)</SectionTitle>
            <Paragraph>
                We comply with all developer policies set forth by Google Play and Apple App Store. For platform-specific purchase policies, refund rules, and data usage practices, refer to:
                <ul>
                    <li><a href="https://www.meta.com/en-gb/help/">Meta Support</a></li>
                    <li><a href="https://www.whatsapp.com/contact">Whatsapp Contact</a></li>
                </ul>
                Anahex does not access or store your bank account details, including but not limited to credit/debit card numbers, UPI credentials, or other financial access data.
                <br />
                We maintain a record of completed transactions strictly for bookkeeping, audit, and support purposes. However, no sensitive financial identifiers are ever stored or visible to us.
            </Paragraph>

            <SectionTitle>12. Updates to Terms</SectionTitle>
            <Paragraph>
                These Terms of Use may be updated from time to time. Continued use of Anahex means you agree to the latest version. If you do not agree with any of the terms, please discontinue to use and write to us at <a href="mailto:policy@anahex.com">policy@anahex.com</a>.
            </Paragraph>

            <Paragraph><em>Last updated: Jan 29, 2026</em></Paragraph>
            <SectionTitle>16. A Note from the Anahex Team</SectionTitle>
            <Paragraph>
                As a newborn platform, we too are learning — every single day — how to live, grow, and contribute to a better, more compassionate society. Please forgive our unintentional mistakes and guide us on this journey.
            </Paragraph>
            <Paragraph>
                Our purpose is to empower the world, never to harm anyone — knowingly or unknowingly. We respect every individual and their choices, especially those rooted in non-violence, mutual respect, and the law of the land.
            </Paragraph>
            <Paragraph>
                If you ever come across anything we’ve done wrong — even unknowingly — please let us know at <a href="mailto:support@anahex.com">support@anahex.com</a>. Help us grow older with you, and give us the opportunity to be your fellow traveler in this learning journey.
            </Paragraph>
            <Paragraph>
                Even when, on a legal front, we may appear to be at an advantage or in the right — its our duty to review every request and concern on moral and ethical grounds. Documents and policies exist to protect the kind and genuine from harm — not to justify hurting the good. We stand by that.
            </Paragraph>
            <Paragraph>
                The day we forget this — we believe, with utmost sincerity — we don't deserve to exist.
            </Paragraph>
            <Paragraph>
                Building a startup, especially in the learning space, is incredibly challenging. Every day, we face:
                <ul>
                    <li>High marketing costs</li>
                    <li>Very low user motivation</li>
                    <li>Very low user retention</li>
                    <li>People need easy hacks than concept depth</li>
                    <li>Low per user revenue</li>
                    <li>A saturated and crowded market</li>
                    <li>Harsh odds of survival</li>
                </ul>
            </Paragraph>
            <Paragraph>
                It often feels like a newborn on ventilation — trying to breathe through tides of negativity, exploitation, legal complexity, limited knowledge, and fierce competition. Yet we rise every day with sincerity. We request your support — and more importantly, your kindness.
            </Paragraph>
            <Paragraph>
                We believe money is simply the fuel that helps us contribute longer — not the reason we exist. We are just as human as you. Treat us like your family. For kind, good, humble human beings — we win only when you win.
            </Paragraph>
            <br />
            <Paragraph>
                With warmth and respect,<br />
                <strong>Your Anahex Team</strong>
            </Paragraph>
        </Container>

    );
};

const Container = styled.div`
  padding: 40px 20px;
  max-width: 800px;
  margin: auto;
  background: #fff;
  font-family: 'Helvetica Neue', sans-serif;
`;

const Heading = styled.h1`
  font-size: 32px;
  font-weight: bold;
  color: #000;
  margin-top: 56px;
  margin-bottom: 24px;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin-top: 32px;
  margin-bottom: 12px;
  color: #333;
`;

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 1.6;
  color: #444;

  ul {
    padding-left: 20px;
    margin: 8px 0;
  }

  li {
    margin-bottom: 6px;
  }
`;

export default TermsPage;
